import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "tbdc-legend-section"
}
const _hoisted_2 = {
  key: 0,
  class: "tbdc-legend-title"
}
const _hoisted_3 = {
  key: 1,
  class: "tbdc-legend-ends"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.colors && _ctx.colors.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.title)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.title), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: "tbdc-legend-bar",
          style: _normalizeStyle({ 'background': _ctx.barBackground })
        }, null, 4),
        (_ctx.ticks && _ctx.ticks.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ticks, (tick, index) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: index,
                  class: "tbdc-legend-tick",
                  style: _normalizeStyle({ 'text-align': _ctx.tickAlign(index) })
                }, _toDisplayString(tick), 5))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}